import type { CertGenParams } from '@yandex-int/k-common';

export const GLKidsAutumn2023 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
}: CertGenParams) => {
    return `<!doctype html>
    <html lang="ru" xmlns="http://www.w3.org/1999/html">

    <head>
        <meta charset="utf-8" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="viewport" content="width=device-width, maximum-scale=1.0, initial-scale=1.0" />
        <style type="text/css">
            /*
            //-----------------------------------------
            // Fonts
            //-----------------------------------------
            */

            @font-face {
                font-family: 'YS Text';
                src: url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2") format("woff2"),
                    url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff") format("woff");
                font-weight: 400;
                font-style: normal;
            }

            /*
            //-----------------------------------------
            // Print specifics
            //-----------------------------------------
            */

            @page {
                size: 210mm 297mm;
                margin: 0;
            }

            @media print {
                html,
                body {
                    color-adjust: exact;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }
            }

            /*
            //-----------------------------------------
            // Scaffolding
            //-----------------------------------------
            */

            html,
            body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;

                /* letter pixel */
                --lx: calc(297mm / 895)
            }

            body {
                font-size: calc(14 * var(--lx));
                font-weight: 400;
                font-family: 'YS Text';
                line-height: calc(20 * var(--lx));
                color: #fff;
                min-height: 100%;
                height: auto !important;
                height: 100%;
                background: #FFFFFF;
                -webkit-text-size-adjust: 100%;
            }

            * {
                box-sizing: border-box;
            }

            /*
            //-----------------------------------------
            // Certificate
            //-----------------------------------------
            */

            .page {
                position: relative;
                width: 210mm;
                height: 297mm;
                overflow: hidden;
                page-break-after: always;
                break-after: page;
                padding: calc(30 * var(--lx));

                background-image: url("https://avatars.mds.yandex.net/get-schoolbook-images/6887102/rlD4237D3pIfNZLWxUNuu/orig");
                background-repeat: no-repeat;
                background-position: 0 0;
                background-size: 100% 100%;
            }

            .logo {
                display: block;
                width: calc(176 * var(--lx));
                margin: calc(2 * var(--lx)) auto 0;
            }

            .title {
                width: calc(422 * var(--lx));
                margin-top: calc(290 * var(--lx));
                margin-left: auto;
                margin-bottom: calc(5 * var(--lx));
                margin-right: auto;
            }

            .title img {
                display: block;
                width: 100%;
            }

            .info {
                text-align: center;
                margin: calc(24 * var(--lx)) auto 0;
                width: calc(450 * var(--lx));
            }

            .info>*:not(:last-child) {
                margin-bottom: calc(4 * var(--lx));
            }

            .name {
                font-size: calc(24 * var(--lx));
                line-height: calc(28 * var(--lx));
                font-weight: 700;
                min-height: calc(56 * var(--lx));
                max-height: calc(84 * var(--lx));
                align-items: center;
                justify-content: center;
                display: flex;
                overflow: hidden;
            }

            .description {
                margin-top: calc(20 * var(--lx));
            }

            .school {
                font-size: calc(18 * var(--lx));
                line-height: calc(24 * var(--lx));
            }

            .signature {
                width: calc(220 * var(--lx));
                margin: 0 auto;
                display: flex;
                position: absolute;
                bottom: calc(34 * var(--lx));
                left: 50%;
                margin-left: calc(110 * var(--lx) * -1);
            }

            .signature__img {
                width: calc(52 * var(--lx));
                margin-right: calc(16 * var(--lx));
            }

            .signature__text {
                font-size: calc(12 * var(--lx));
                line-height: calc(14 * var(--lx));
            }
        </style>
    </head>

    <body>
        <div class="page">
            <img class="logo" src="https://avatars.mds.yandex.net/get-schoolbook-images/6887102/sDU-22THyGNgzSF88pmHp/orig"
                alt="Лого Яндекс">

            <div class="title">
                <img src="https://avatars.mds.yandex.net/get-schoolbook-images/6887102/7LeqG6nEwd1UUNxbToPvK/orig"
                    alt="Благодарственное письмо>">
            </div>

            <div class="info">
                <div class="name">
                    ${lastName ? `${lastName}` : ''}
                    ${firstName ? `${firstName}` : ''}
                    ${middleName ? `${middleName}` : ''}
                </div>

                <div class="school">${schoolName ? `${schoolName}` : ''}</div>

                <div class="description">
                    Ваши ученики участвовали в игровой олимпиаде по математике Плюс Детям! Спасибо вам, что каждый день помогаете детям делать всё новые и новые открытия
                </div>
            </div>

            <div class="signature">
                <img class="signature__img"
                    src="https://avatars.mds.yandex.net/get-schoolbook-images/5623482/TmWU32QJBvWbsaTNfH8fd/orig"
                    alt="Подпись Татьяна Умряева" />

                <div class="signature__text">
                    Татьяна Умряева,<br />руководитель Плюс Детям<br /><br />декабрь 2023 года
                </div>
            </div>
        </div>
    </body>

    </html>`;
};
